import { KeyValue } from "../../home/models/OtherTypes";
import { createWarehouse, WarehouseModel } from "../../products/models/WarehouseModel";

export interface BasicUserInfo {
    id: string;
    userName: string;

    email?: string;
    countryCode?: string;
    phoneNo?: string;

    isLocal: boolean;
    isEmployee: boolean;
    isRestricted: boolean;
}

export interface UserRolesModel {
    keyHash: number;
    userName: string;
    displayName?: string;
    providerKey?: string;
    accountImageUrl?: string;

    userId: string;
    customerId: number;

    isAdministrator: boolean;
    isGeneralManager: boolean;
    isProductManager: boolean;
    isDataEntry: boolean;
    isStoreManager: boolean;
    isSalesSupervisor: boolean;
    isSalesperson: boolean;
    isStockeeper: boolean;
    isDeliveryPerson: boolean;
    isNotEmployee: boolean;

    isLocal: boolean;
    isRestricted: boolean;
    isMobile: boolean;
    isAppleDevice: boolean;

    defaultWarehouse: WarehouseModel;
    warehouses: WarehouseModel[];

    paymentAccounts: KeyValue<number, string>[];
}

export const createUserRolesInfo = (): UserRolesModel => ({
    keyHash: 0,
    userName: "",
    userId: "",
    customerId: 0,
    isAdministrator: false,
    isGeneralManager: false,
    isProductManager: false,
    isDataEntry: false,
    isStoreManager: false,
    isSalesSupervisor: false,
    isSalesperson: false,
    isStockeeper: false,
    isDeliveryPerson: false,
    isNotEmployee: false,
    isLocal: false,
    isRestricted: false,
    isMobile: false,
    isAppleDevice: false,
    defaultWarehouse: createWarehouse(),
    warehouses: [],
    paymentAccounts: []
});